import "./SelectedEquipment.html";
import "./SelectedEquipment.scss";

import "./CameraConfigurations/CameraConfigurationsComponent";
import "./ConnectSiteEquipmentToHardware/ConnectSiteEquipmentToHardwareComponent";
import "./EditEquipmentDetails/EditEquipmentDetailsComponent";
import "./EquipmentDetails/EquipmentDetailsComponent";
import "./MapConfigurations/MapConfigurationsComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SelectedEquipmentComponentController from "./SelectedEquipmentComponentController";

export default class SelectedEquipmentComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            isEditable: "=",
            isSidebarCollapsed: "<",
            map: "<",
            onAddEquipment: "&",
            onAddToMap: "&",
            onDelete: "&",
            selectedSiteEquipment: "=",
            site: "=",
            siteEquipment: "<",
        };
        this.controller = SelectedEquipmentComponentController;
        this.templateUrl = "/App/Components/Site/DesignAndPlanning/SelectedEquipment/SelectedEquipment.html";
    }
}

module("mmManagePortal").component("mmSelectedEquipment", new SelectedEquipmentComponent());
